import React from "react";
import { Link } from "react-router-dom";
import { FileSignature, ChevronRight } from "lucide-react";
import { StatusBadge, SIGNER_META } from "@/components/contracts/contractUtils";

export default function ContractsList({ contracts, empty }) {
  if (!contracts) return <div className="text-[var(--ff-text-dim)] font-mono-ui text-sm">Loading…</div>;
  if (!contracts.length) return <div className="surface-card p-10 text-center text-sm text-[var(--ff-text-dim)]" data-testid="contracts-empty">{empty}</div>;
  return (
    <div className="surface-card divide-y divide-[var(--ff-border)]" data-testid="contracts-list">
      {contracts.map((c) => (
        <Link key={c.id} to={`/contracts/${c.id}`} className="flex flex-wrap items-center gap-4 p-4 hover:bg-[var(--ff-surface-hover)] transition-colors" data-testid={`contract-row-${c.id}`}>
          <FileSignature size={18} className="text-[var(--ff-red)] shrink-0" />
          <div className="flex-1 min-w-[180px]">
            <div className="font-display text-lg leading-tight">{c.title}</div>
            <div className="flex flex-wrap gap-2 mt-1">
              {c.signers.map((s) => (
                <span key={s.role} className="font-mono-ui text-[0.6rem] uppercase tracking-[0.12em]" style={{ color: SIGNER_META[s.role]?.color }}>
                  {s.signed ? "✓ " : "○ "}{SIGNER_META[s.role]?.label}: {s.name}
                </span>
              ))}
            </div>
          </div>
          {c.my_pending && <span className="bg-[var(--ff-red)] text-white px-2 py-0.5 font-mono-ui text-[0.6rem] uppercase tracking-[0.15em] animate-pulse" data-testid={`contract-sign-now-${c.id}`}>Sign Now</span>}
          <StatusBadge status={c.status} testId={`contract-status-${c.id}`} />
          <span className="font-mono-ui text-[0.6rem] text-[var(--ff-text-dim)]">{new Date(c.created_at).toLocaleDateString()}</span>
          <ChevronRight size={14} className="text-[var(--ff-text-dim)]" />
        </Link>
      ))}
    </div>
  );
}
